// --------------------------- Global
window.theme = window.theme || {};

// jQuery as a global module
import './global.js';

// --------------------------- Helpers / Polyfills

// Helper : Old Browsers
import './helpers/polyfills.js'

// Helper : General
import './helpers/helpers.js'

// --------------------------- Modules

// Module : Glide
import './modules/glide.js';

// Module : Menus
import './modules/menus.js';

// Module : Accordion
import './modules/accordion.js';

// Module : Tabs
import './modules/tabs.js';

// Module : Mega menu
import './modules/mega-menu.js';

// Module : Personalise
import './modules/personalise.js' 

// Module : Images
import './modules/media.js'

// Module : Hotspots
import './modules/hotspots.js';

// --------------------------- Shopify

// Module : Currency
import './shopify/currency.js';

// Module : General
import './shopify/general.js';

// Theme : Colour Swatches
import './shopify/swatch.js';

// Theme : Quick View
import './shopify/quick-view.js'

// Theme : Recently Viewed
import './shopify/recently-viewed.js'

// Module : Account
import './shopify/account.js';

// Module : Variants
import './shopify/variants.js';

// Module : Filter
import './shopify/filter.js';

// Module : Cart
import './shopify/cart.js';

// Module : Groups
import './shopify/groups.js';

// Module : Filter
import './shopify/filter.js';
